import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Email, Key, Lock } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import { auntheticate } from '../../../../../redux/reducers/aunthSlice';
import { useDispatch } from 'react-redux';
const useStyles = makeStyles((theme) => ({
  textFields: {
    height: '12vh',
    margin: '50px, 0px',
    paddingLeft: '20px',
    fontVariant: 'normal',
  },
}));

export default function AuthSession(props) {
  const dispatch = useDispatch();
  const { setAunth, aunth } = props;
  const login = () => {
    setAunth(!aunth);
    dispatch(auntheticate());
  };

  const classes = useStyles();
  return (
    <form>
      <Box
        sx={{
          padding: '2vh',
          justifyContent: 'center',
        }}
      >
        <TextField
          variant="outlined"
          placeholder="example@example.com"
          label="enter your email"
          fullWidth
          className={classes.textFields}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Email />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          variant="outlined"
          placeholder="enter your password"
          label="enter your password"
          fullWidth
          className={classes.textFields}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Key />
              </InputAdornment>
            ),
          }}
        />
        <FormControl>
          <FormControlLabel control={<Checkbox />} label="keep me logged in" />
        </FormControl>
      </Box>
      <Box sx={{ padding: '0vh 5vw' }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            align="center"
            sx={{
              width: '100%',
              alignItems: 'center',
              align: 'center',
            }}
          >
            <Button
              onClick={login}
              variant="contained"
              color="primary"
              // type="submit"
              sx={{ width: '50%' }}
            >
              <Link to="/home">sign in</Link>
            </Button>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}
